import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

$.fn.senraciner = function() {
  let self = this

  gsap.registerPlugin(ScrollTrigger);

  $('.grid--style--animated-stats').each(function( index ) {
    $(this).closest('.page-section').css('min-height', $(this).outerHeight());
  });

  var el1 = $('.grid--style--animated-stats .grid__item:nth-child(1)');
  var el2 = $('.grid--style--animated-stats .grid__item:nth-child(2)');
  var el3 = $('.grid--style--animated-stats .grid__item:nth-child(3)');

  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function() {
      var tl_stats = gsap.timeline();
      tl_stats.from(el1,
      {
        x: '-100%',
        duration: 600
      })
      .from(el3,
      {
        x: '100%',
        duration: 600
      })
      .from(el2,
      {
        y: '100%',
        duration: 600
      });
      ScrollTrigger.create({
        trigger: ".grid--style--animated-stats",
        animation: tl_stats,
        start: "bottom 130%",
        end: "top 20%",
        scrub: .5,
      });
    },
    "(max-width: 767.98px)": function() {
      var tl_1 = gsap.timeline().from(el1, {
        x: '-100%',
        duration: 600
      });
      ScrollTrigger.create({
        trigger: el1,
        animation: tl_1,
        start: "top 80%",
        end: "top 20%",
        scrub: 1,
      });
      var tl_2 = gsap.timeline().from(el2, {
        x: '100%',
        duration: 600
      });
      ScrollTrigger.create({
        trigger: el2,
        animation: tl_2,
        start: "top 80%",
        end: "top 20%",
        scrub: 1,
      });
      var tl_3 = gsap.timeline().from(el3, {
        x: '-100%',
        duration: 600
      });
      ScrollTrigger.create({
        trigger: el3,
        animation: tl_3,
        start: "top 80%",
        end: "top 20%",
        scrub: 1,
      });
    }
  });

  const rows = gsap.utils.toArray('.row');
  rows.forEach((row, i) => {
    const fadeIn = gsap.fromTo(row, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
    ScrollTrigger.create({
      trigger: row,
      start: "top 80%",
      animation: fadeIn,
      toggleActions: 'play none none none',
      once: true,
    });
  });

  const delays = gsap.utils.toArray('.delay');
  delays.forEach((delay, i) => {
    const fadeIn = gsap.fromTo(delay, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
    ScrollTrigger.create({
      trigger: delay,
      start: "top center",
      animation: fadeIn,
      toggleActions: 'play none none none',
      once: true,
    });
  });

  $( ".animation--wheel" ).append('<div class="animation--wheel__wheel"></div>');
  const wheels = gsap.utils.toArray('.animation--wheel');
  var tl_wheel = gsap.timeline();
  tl_wheel.to(".animation--wheel__wheel", {left: '50%', rotation: 360, duration: 1, ease: 'ease'})
  .to(".animation--wheel__wheel", {left: '50%', duration: .25, ease: 'ease'})
  .to(".animation--wheel__wheel", {left: 'calc(100% + 300px)', rotation: 360*2, duration: 1, ease: 'easeOut'});
  wheels.forEach((wheel, i) => {
    ScrollTrigger.create({
      trigger: wheel,
      start: 'top 80%',
      end: 'top 20%',
      animation: tl_wheel,
      toggleActions: 'restart none restart none',
    });
  });

  return function() {
    return self
  }()
}
